import { Paper, Title } from "@mantine/core";
import { HiPlus } from "react-icons/hi2";
import CustomSearchBar from "../../../../ui/CustomSearchBar/CustomSearchBar";
import { CustomText } from "../../../../ui/CustomText/CustomText";
import CustomButton from "../../../../ui/CustomButton/CustomButton";

const UserFilters = ({
  title,
  icon,
  subtitle,
  showCreateButton,
  createButtonText,
  onAddUser,
  isCreating,
  hasCreateFn,
  onSearchChange,
  badgeCount,
  searchPlaceholder,
}) => {
  return (
    <div className="flex-shrink-0">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-2">
        <div>
          <Title order={2} size="h3" className="flex items-center gap-2">
            {icon}
            {title}
          </Title>
          <CustomText c="dimmed" size="sm" mt={4}>
            {subtitle}
          </CustomText>
        </div>
        {showCreateButton && hasCreateFn && (
          <CustomButton
            onClick={onAddUser}
            disabled={isCreating}
            leftSection={<HiPlus size={16} />}
            className="self-start"
          >
            {createButtonText}
          </CustomButton>
        )}
      </div>

      <Paper p="md" withBorder>
        <CustomSearchBar
          placeholder={searchPlaceholder}
          onSearchChange={onSearchChange}
          badgeCount={badgeCount}
          debounceDelay={500}
        />
      </Paper>
    </div>
  );
};

export default UserFilters;
